module.exports = __webpack_public_path__ + "img/CameraAltOutlined.7714dc63.svg";